import './index.scss';

import './js/navigation';
import './js/smooth-scroll';
import './js/jquery.bxslider';

jQuery(document).ready(function($) {

    // Modal
    $modalSellingPoints = $('.modal-selling-points');

    $modalSellingPoints.on('click', function(e){
        $modalSellingPoints.addClass('hide');

        // display store buttons
        $('.selling-point.utilidades').show();

        // if( e.target != this ) 
        //     return true;

        // e.preventDefault();
    });

    $('.product-popup').on('click', function(e) {
        e.preventDefault();
        $this = $(this);

        $modalSellingPoints.find('a[data-base-url]').each(function() {
            var baseUrl = $(this).attr('data-base-url');
            if (baseUrl) {
                $(this).attr('href', baseUrl);
            }
        });

        if ($this.attr('data-link-dentalcremer')) {
            $modalSellingPoints.find('.selling-point.dentalcremer a').attr('href', $this.attr('data-link-dentalcremer'));
        } 

        if ($this.attr('data-link-dentalspeed')) {
            $modalSellingPoints.find('.selling-point.dentalspeed a').attr('href', $this.attr('data-link-dentalspeed'));
        } 

        if ($this.attr('data-link-utilidades')) {
            $modalSellingPoints.find('.selling-point.utilidades a').attr('href', $this.attr('data-link-utilidades'));
        } 

        $modalSellingPoints.removeClass('hide');

        // hide store buttons
        if ($this.hasClass('no-utilidades')) {
            $('.selling-point.utilidades').hide();
        }
    });

    // Banner
    $('.header-banner').bxSlider({
        auto: true,
        pager: false,
    });

    // Menu mobile
    $menu = $('.main-navigation ul');
    $('.menu-toggle').on('click', function(e) {
        e.preventDefault();
        $menu[$menu.is(':visible') ? 'hide' : 'show'](300);
    });

    // Slide processos
    if (window.innerWidth <= 750) {
        $('.process .process-items').bxSlider({
            auto: false,
            pager: true,
            minSlides: 1,
            maxSlides: 2,
            moveSlides: 1,
            slideWidth: 215,
            shrinkItems: false,
            infiniteLoop: false,
            hideControlOnEnd: true,
            slideMargin: 20,
            responsive: false,
        });
    }
    
});